import React from 'react'
import { createRoot } from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { AuthProvider } from './contexts/AuthContext'
import { LocalizationProvider } from './contexts/LocalizationContext'
import { NavigationProvider } from './contexts/NavigationContext'
import { ActiveProfileProvider } from './contexts/ActiveProfileContext'
import { ClientViewProvider } from './contexts/ClientViewContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { HelmetProvider } from 'react-helmet-async'
import { I18nextProvider } from 'react-i18next'
import { ErrorBoundary } from './components/ErrorBoundary'
import { registerChunkReloadHandler } from './utils/chunkReload'
import { system } from './theme'
import App from './App.tsx'
import i18n from './i18n'

// Recover from stale-deploy chunk load failures before React renders.
registerChunkReloadHandler()

document.documentElement.classList.add('js')

// Import CSS files BEFORE the app renders
import './index.css'

// Import Firebase Auth Debugger for development
if (import.meta.env.DEV) {
  import('./utils/firebaseAuthDebugger')
}

// Disable StrictMode to avoid dev-only double render mounts while investigating duplicate loads
const RootWrapper = ({ children }: { children: React.ReactNode }) => <>{children}</>

createRoot(document.getElementById('root')!).render(
  <RootWrapper>
    <HelmetProvider>
    <I18nextProvider i18n={i18n}>
      <ChakraProvider value={system}>
        <LocalizationProvider>
          <AuthProvider>
            <ThemeProvider>
              <NavigationProvider>
                <ActiveProfileProvider>
                  <ClientViewProvider>
                    <ErrorBoundary>
                      <App />
                    </ErrorBoundary>
                  </ClientViewProvider>
                </ActiveProfileProvider>
              </NavigationProvider>
            </ThemeProvider>
          </AuthProvider>
        </LocalizationProvider>
      </ChakraProvider>
    </I18nextProvider>
    </HelmetProvider>
  </RootWrapper>,
)

document.getElementById('prerender-content')?.remove()
